import type { TranslationMessages } from '../types';

export const ra: TranslationMessages = {
      configurable: {
        customize: 'Tùy chỉnh',
      },
      action: {
        toggle_theme: 'Chế độ tối / sáng',
        clear_array_input: 'Xóa tất cả',
        add: 'Thêm',
        remove: 'Xóa',
        choose_language: 'Chọn ngôn ngữ',
        skip: 'Bỏ qua',
        actions: 'Hành động',
        create: 'Tạo mới',
        clear: 'Xóa',
        apply: 'Áp dụng',
        help: 'Trợ giúp',
        support: 'Hỗ trợ',
        open: 'Mở',
        previous: 'Trước',
        next: 'Tiếp',
        finish: 'Hoàn thành',
        close: 'Đóng',
        cancel: 'Hủy',
        load_more: 'Tải thêm',
        confirm: 'Xác nhận',
        edit: 'Chỉnh sửa',
        show: 'Xem',
        completed: 'Đã hoàn thành',
        available: 'Có sẵn',
        review: 'Xem lại',
        start: 'Bắt đầu',
        filter: 'Lọc',
        add_filter: 'Thêm bộ lọc',
        apply_filters: 'Áp dụng bộ lọc',
        clear_filters: 'Xóa bộ lọc',
        back_to_list: 'Quay lại danh sách',
        search_placeholder: 'Tìm kiếm...',
        loading: 'Đang tải...',
        error_loading: 'Lỗi tải dữ liệu',
        failed_to_load: 'Không thể tải dữ liệu. Vui lòng thử lại.',
        failed_to_save: 'Không thể lưu. Vui lòng thử lại.',
        failed_to_delete: 'Không thể xóa. Vui lòng thử lại.',
        failed_to_create: 'Không thể tạo. Vui lòng thử lại.',
        failed_to_update: 'Không thể cập nhật. Vui lòng thử lại.',
        clear_all_filters: 'Xóa tất cả bộ lọc',
        table_view: 'Xem dạng bảng',
        card_view: 'Xem dạng thẻ',
        select_category: 'Chọn danh mục',
        select_status: 'Chọn trạng thái',
        minimum_amount: 'Số tiền tối thiểu',
        saving: 'Đang lưu...',
      },
      message: {
        clear_array_input: 'Xóa tất cả các mục?',
        forbidden: 'Bạn không có quyền truy cập trang này',
        yes: 'Có',
        no: 'Không',
      },
      saved_queries: {
        label: 'Lưu truy vấn',
      },
      auth: {
        forgot_password: 'Quên mật khẩu?',
        remember_password: 'Ghi nhớ mật khẩu',
        reset_password: 'Đặt lại mật khẩu',
        email: 'Email',
        close_window: 'Đóng',
        set_new_password: 'Cập nhật mật khẩu',
        username_email_password_required:
          'Tên người dùng/email và mật khẩu là bắt buộc',
        invalid_credentials: 'Tên người dùng/email hoặc mật khẩu không đúng',
        invalid_username_email: 'Tên người dùng/email không đúng',
        invalid_password: 'Mật khẩu không đúng',
        invalid_username: 'Tên người dùng không đúng',
        invalid_email: 'Email không đúng',
        invalid_username_or_email: 'Tên người dùng/email không đúng',
        username_or_email: 'Tên người dùng/email',
        username_or_email_placeholder: 'Nhập tên đăng nhập hoặc email',
        password: 'Mật khẩu',
        password_placeholder: 'Nhập mật khẩu của bạn',
        sign_in: 'Đăng nhập',
        welcome_back:
          'Chào mừng trở lại! Vui lòng đăng nhập vào tài khoản của bạn.',
        or: 'hoặc',
        sign_in_with_passkey: 'Đăng nhập bằng Passkey',
        passkey_error: 'Đăng nhập bằng passkey thất bại',
        passkey_not_supported: 'Thiết bị này không hỗ trợ passkey',
        no_passkeys:
          'Chưa có passkey nào được đăng ký. Vui lòng đăng nhập bằng tên người dùng/mật khẩu trước, sau đó đăng ký passkey trong cài đặt hồ sơ của bạn.',
        passkey_register: 'Đăng ký Passkey',
        passkey_register_success: 'Đăng ký passkey thành công',
        passkey_register_error: 'Đăng ký passkey thất bại',
        passkey_not_registered:
          'Chưa có passkey nào được đăng ký. Vui lòng đăng nhập bằng tên người dùng/mật khẩu trước, sau đó đăng ký passkey trong cài đặt hồ sơ của bạn.',
        register_passkey: 'Đăng ký Passkey',
        register_passkey_description:
          'Bạn có muốn thiết lập passkey để đăng nhập nhanh hơn và an toàn hơn không? Bạn có thể sử dụng vân tay, nhận diện khuôn mặt hoặc mã PIN thiết bị.',
      },
    };
